import { render } from "./stat-users-inactive.vue?vue&type=template&id=5067f143"
import script from "./stat-users-inactive.vue?vue&type=script&lang=js"
export * from "./stat-users-inactive.vue?vue&type=script&lang=js"
script.render = render

export default script